import axios from "axios";
import { loadStripe } from "@stripe/stripe-js";

export default {
  methods: {
    sp_init(payload) {
      let stripe = {
        key: "",
        paymentKey: "",
        paymentKey2: "",
        res: null,
        saveCard: true,
        savedCards: [],
        newCardValid: false,
        cardElement: null,
        cardSelected: null,
        ready: false,
        confirmed: false,
        preAuthorize: false,
        payerId: "",
        owner: payload.owner,
      };

      return this.sp_getRequest(payload)
        .then(async rpdata => {
          //console.log("stripe data", rpdata);
          if (rpdata.result == "ok") {
            stripe.key = rpdata.data.key;
            stripe.paymentKey = rpdata.data.payment_key;
            stripe.paymentKey2 = rpdata.data.payment_key2;
            stripe.preAuthorize = rpdata.data.pre_auth != null && rpdata.data.pre_auth;

            stripe.res = await loadStripe(stripe.key, {
              stripeAccount: rpdata.data.sub_account,
            });

            console.log("stripe data", stripe);

            if (rpdata.data.cards) {
              stripe.savedCards = rpdata.data.cards;
            }
            if (rpdata.data.payer_id) {
              stripe.payerId = rpdata.data.payer_id;
              this.sp_setPayerId(stripe.payerId);
            }
            if (stripe.savedCards.length > 0) {
              stripe.cardSelected = stripe.savedCards[0].id;
            } else {
              stripe.cardSelected = "new-card";
            }
            stripe = this.sp_createElements(stripe);

            stripe.ready = true;

            return stripe;
          }
        })
        .catch(err => {
          console.log(err);

          return {};
        }); // eslint-disable-line
    },

    sp_createElements(stripe) {
      var elements = stripe.res.elements();

      // Custom styling can be passed to options when creating an Element.
      // (Note that this demo uses a wider set of styles than the guide below.)
      var style = {
        base: {
          iconColor: "#666EE8",
          color: "#32325d",
          // lineHeight: "40px",
          fontWeight: 300,
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#aab7c4",
          },
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a",
        },
      };

      // Create an instance of the card Element.
      stripe.cardElement = elements.create("card", { style: style });

      // Add an instance of the card Element into the `card-element` <div>.
      stripe.cardElement.mount("#card-element");

      // Update radio when focused
      stripe.cardElement.on("focus", () => {
        stripe.cardSelected = "new-card";
      });
      // Handle real-time validation errors from the card Element.
      if (stripe.owner != null) {
        let that = stripe.owner;
        stripe.cardElement.on("change", function(event) {
          console.log(event);
          that.stripe.newCardValid = event.complete;
          /*         if (event.complete) {
            that.stripe.newCardValid = event.complete;
          } */

          var displayError = document.getElementById("card-errors");
          if (event.error) {
            if (displayError) displayError.textContent = event.error.message;
            that.payFailedMessage = event.error.message;
          } else {
            if (displayError) displayError.textContent = "";
            that.payFailedMessage = "";
          }
        });
      }

      return stripe;
    },

    sp_destroyElements(stripe) {
      if (stripe != null) {
        if (stripe.savedCards != null) stripe.savedCards = [];
        if (stripe.cardElement != null) stripe.cardElement.unmount();
        if (stripe.res != null) {
          //var elements = stripe.res.elements();
          //elements.destoryElements();
        }
      }

      return stripe;
    },

    sp_getSessionKey() {
      let sessionKey;
      if (this.$router.currentRoute.name == "GiftCardAdd") sessionKey = this.$store.getters.serviceSessionKey;
      else sessionKey = this.$store.state.store.sessionKey;

      console.log("sp_getSessionKey", sessionKey);
      return sessionKey;
    },

    sp_getStorageKey() {
      let storageKey;
      if (this.$router.currentRoute.name == "GiftCardAdd") storageKey = this.$store.getters.memberCompanyCode;
      else storageKey = this.$store.getters.storeCompanyCode;

      let phoneNo = "";
      if (this.$store.state.member != null) phoneNo = this.$store.state.member.PhoneId;
      else phoneNo = this.$store.state.guest.phone1;
      if (phoneNo != "") storageKey += "_" + phoneNo;

      console.log("sp_getStorageKey", storageKey);
      return storageKey;
    },

    sp_getRequest(payload) {
      let jreq = {
        sessionId: this.$store.state.appSessionID,
        sessionKey: this.sp_getSessionKey(),
        data: {
          amount: payload.amount,
          currency: payload.currency,
          payer_id: payload.payerId,
          withholding: payload.withholding,
        },
      };
      let request = JSON.stringify(jreq);

      return axios
        .post(this.$store.state.stripeApiUrl + "getrequest", request, this.$store.state.httpReqOpt)
        .then(result => result.data)
        .then(data => {
          return data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    sp_payBySavedCard(payload) {
      let jreq = {
        sessionId: this.$store.state.appSessionID,
        sessionKey: this.sp_getSessionKey(),
        data: {
          amount: payload.amount,
          currency: payload.currency,
          payer_id: payload.payerId,
          card_id: payload.cardId,
        },
      };
      let request = JSON.stringify(jreq);

      return axios
        .post(this.$store.state.stripeApiUrl + "paybysavedcard", request, this.$store.state.httpReqOpt)
        .then(result => result.data)
        .then(data => {
          return data;
        })

        .catch(error => {
          console.log(error);
        });
    },

    sp_removeCard(cardId) {
      let jreq = {
        sessionId: this.$store.state.appSessionID,
        sessionKey: this.sp_getSessionKey(),
        data: { card_id: cardId },
      };
      let request = JSON.stringify(jreq);

      return axios
        .post(this.$store.state.stripeApiUrl + "removecard", request, this.$store.state.httpReqOpt)
        .then(result => result.data)
        .then(data => {
          return data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    sp_capturePayment(orderId) {
      let jreq = {
        sessionId: this.$store.state.appSessionID,
        sessionKey: this.sp_getSessionKey(),
        data: { order_id: orderId },
      };
      let request = JSON.stringify(jreq);

      return axios
        .post(this.$store.state.stripeApiUrl + "capture", request, this.$store.state.httpReqOpt)
        .then(result => result.data)
        .then(data => {
          return data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    /*     sp_verifyPayment(token) {
      let jreq = {
        sessionId: this.$store.state.appSessionID,
        sessionKey: this.sp_getSessionKey(),
        data: { order_id: token.id },
      };
      let request = JSON.stringify(jreq);

      return axios
        .post(this.$store.state.stripeApiUrl + "getPayVerify", request, this.$store.state.httpReqOpt)
        .then(result => result.data)
        .then(data => {
          return data;
        })
        .catch(error => {
          console.log(error);
        });
    },   */

    sp_setPayerId(payerId) {
      if (this.$idb == null) return false;

      let that = this;
      return new Promise(function(resolve) {
        let key = "SP_PID_" + that.sp_getStorageKey();
        that.$idb.setting
          .put({ name: key, value: payerId })
          .then(() => {
            resolve(true);
          })
          .catch(error => {
            console.log("setPayerId catched", error);
            resolve(false);
          });
      });
    },

    sp_getPayerId() {
      if (this.$idb == null) return "";

      let that = this;
      return new Promise(function(resolve) {
        let key = "SP_PID_" + that.sp_getStorageKey();
        that.$idb.setting
          .get(key)
          .then(record => resolve(record.value))
          .catch(() => resolve(""));
      });
    },

    sp_getSaveCard() {
      let saveCard = true;
      let key = "SP_SCD_" + this.sp_getStorageKey();
      if (localStorage.getItem(key)) {
        saveCard = localStorage.getItem(key) === "true";
      }

      return saveCard;
    },

    sp_setSaveCard(saveCard) {
      let key = "SP_SCD_" + this.sp_getStorageKey();
      localStorage.setItem(key, saveCard);
    },

    sp_setPayerId_v1(payerId) {
      let key = "SP_PID_" + this.sp_getStorageKey();
      localStorage.setItem(key, payerId);
    },

    sp_getPayerId_v1() {
      let payerId = "";
      let key = "SP_PID_" + this.sp_getStorageKey();
      if (localStorage.getItem(key)) {
        payerId = localStorage.getItem(key);
      }

      return payerId;
    },
  },
};
